module.exports = __webpack_public_path__ + "img/hero_3.8f42983c.jpeg";